import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";
import { currencyFormatter } from "src/utils/common";

type SalesOverviewPoint = {
  date: string;
  totalSales: number;
};

interface SalesOverviewChartProps {
  data: SalesOverviewPoint[];
}

const SalesOverviewChart: React.FC<SalesOverviewChartProps> = ({ data }) => {
  return (
    <div className="mt-4 h-44 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#E5E7EB" vertical={false} />
          <XAxis dataKey="date" hide />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              borderColor: "#E5E7EB",
              fontSize: "12px",
            }}
            labelStyle={{ fontWeight: 600 }}
            formatter={(value?: number) =>
              currencyFormatter(value || 0, "IN", 2)
            }
          />
          <Bar dataKey="totalSales" fill="#A5B4FC" radius={[8, 8, 8, 8]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesOverviewChart;
